import {z} from 'src/lib'
import {OperacionLCTCFields, OperacionLCTCCuentaFields, OperacionLCTCCuentaLimiteFields} from './fields'
import {schemaEntityWithId} from 'src/types'

export const schemaFormOperacionLCTCCuenta = z.object({
    [OperacionLCTCCuentaFields.CodClienteTipo]: z.number({required_error: 'El Tipo de Cliente es requerido.'}),
    [OperacionLCTCCuentaFields.CodClienteSubTipo]: z.number().nullable(),
    [OperacionLCTCCuentaFields.DescClienteTipo]: z.string().optional(),
    [OperacionLCTCCuentaFields.DescClienteSubTipo]: z.string().optional(),
    [OperacionLCTCCuentaLimiteFields.LimiteConcertacion]: z.string().min(1, 'El límite de concertación es requerido.'),
    [OperacionLCTCCuentaLimiteFields.LimiteLiquidacionDVP]: z.string().nullable().optional(),
    [OperacionLCTCCuentaLimiteFields.LimiteLiquidacionFOP]: z.string().nullable().optional(),
    _subTiposDisponibles: z.boolean().optional()
})
    .refine(
        (data) => {
            if (data._subTiposDisponibles && data[OperacionLCTCCuentaFields.CodClienteSubTipo] == null) {
                return false;
            }

            return true;
        },
        {
            message: 'El Subtipo de Cliente es requerido.',
            path: [OperacionLCTCCuentaFields.CodClienteSubTipo],
        }
    );

export type FormOperacionLCTCCuenta = z.infer<typeof schemaFormOperacionLCTCCuenta>;

export const schemaFormOperacionLCTC = z
    .object({
            [OperacionLCTCFields.CodPais]: z.number({required_error: 'El país es requerido.'}),
            [OperacionLCTCFields.CodUnidadNegocio]: z.number({required_error: 'La unidad de negocio es requerida.'}),
            [OperacionLCTCFields.CodSectorComercial]: z.coerce.number({invalid_type_error: 'El sector comercial es requerido.'}).min(1, {message: 'El sector comercial es requerido.'}),
            
            [OperacionLCTCFields.FechaSolicitud]: z.date({required_error: 'La fecha de solicitud es requerida.'}),
            [OperacionLCTCFields.FechaVencimiento]: z.date({required_error: 'La fecha de vencimiento es requerida.'}),
            [OperacionLCTCFields.Observaciones]: z.string().optional().nullable(),

            [OperacionLCTCFields.Cuentas]: z.array(schemaFormOperacionLCTCCuenta)
                .min(1, { message: 'Debe agregar al menos una cuenta.' }),
    })
    .refine(
        (schema) => {
                if (schema.fechaVencimiento && schema.fechaSolicitud) {
                        return schema.fechaVencimiento.getTime() >= schema.fechaSolicitud.getTime();
                }

                return true;
        },
        {
                message: 'La fecha de vencimiento debe ser mayor o igual a la fecha de solicitud.',
                path: [OperacionLCTCFields.FechaVencimiento],
        }
    );

export type FormOperacionLCTC = z.infer<typeof schemaFormOperacionLCTC>

export const schemaOperacionLCTC = z
    .object({
            [OperacionLCTCFields.CodOperacionLCTC]: z.number(),
            [OperacionLCTCFields.CodPais]: z.number(),
            [OperacionLCTCFields.NombrePais]: z.string(),
            [OperacionLCTCFields.CodUnidadNegocio]: z.number(),
            [OperacionLCTCFields.DescUnidadNegocio]: z.string(),
            [OperacionLCTCFields.CodSectorComercial]: z.number(),
            [OperacionLCTCFields.DescSectorComercial]: z.string(),
            [OperacionLCTCFields.FechaSolicitud]: z.coerce.date(),
            [OperacionLCTCFields.FechaVencimiento]: z.coerce.date(),
            [OperacionLCTCFields.CodEstado]: z.number(),
            [OperacionLCTCFields.DescEstado]: z.string(),
            [OperacionLCTCFields.FechaAprobacion]: z.coerce.date().nullable(),
            [OperacionLCTCFields.FechaAlta]: z.coerce.date().nullable(),
            [OperacionLCTCFields.IdUsuarioAlta]: z.number(),
            [OperacionLCTCFields.NombreUsuarioAlta]: z.string(),
            [OperacionLCTCFields.ApellidoUsuarioAlta]: z.string(),

            [OperacionLCTCFields.Observaciones]: z.string().nullable(),
            [OperacionLCTCFields.EstadoFinalizado]: z.boolean(),
            [OperacionLCTCFields.PermiteEditarOperacion]: z.boolean(),
            [OperacionLCTCFields.PermiteEliminarOperacion]: z.boolean(),
    })
    .merge(schemaEntityWithId)

export type OperacionLCTC = z.infer<typeof schemaOperacionLCTC>